import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { LocalStorageConstants } from 'src/app/common/LocalStorageConstants';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  constructor(private http: HttpClient) {  
   }

  savecustomer(model: any) {
    model.idClient = Number(localStorage.getItem(LocalStorageConstants.CLIENT_ID));
    return this.http.post(environment.apiUrl + 'Customer/SaveCustomer', model);
  }

  updatecustomer(model: any) {
    return this.http.patch(environment.apiUrl + 'Customer/UpdateCustomer', model);
  }

  GetAllCustomer(): Observable<any> {
    return this.http.get(environment.apiUrl + 'Customer/GetAllCustomer?idClient=' + Number(localStorage.getItem(LocalStorageConstants.CLIENT_ID)));
  }

  GetById(id): Observable<any> {
    return this.http.get(environment.apiUrl + 'Customer/GetById?id=' + id);
  }

  delete(id) {
    return this.http.delete(environment.apiUrl + 'Customer/DeleteCustomer?id=' + id);
  }
}
